import { purple } from '@mui/material/colors';

const customCodesSx = (theme) => ({
    buttons: {
        backgroundColor: purple[600],
        '&:hover': {
            backgroundColor: purple[800],
        },
        '&:active': {
            backgroundColor: purple[800],
        },
    },

    textInputWrapper: {
        paddingBottom: '32px',
    },

    textInput: {
        width: '500px',
    },
});

export default customCodesSx;
